import React from 'react';
import api from '../../services/api';
import './BlockedPage.css';

const BlockedPage: React.FC = () => {
  const message = localStorage.getItem('blocked_message') ||
    'Your account has been suspended. Please contact support.';

  const handleSignOut = async () => {
    localStorage.removeItem('blocked_message');
    await api.logout().catch(() => {});
    window.location.href = '/';
  };

  return (
    <div className="blocked-page">
      <div className="blocked-card">
        <div className="blocked-icon">🚫</div>
        <h1>Account Suspended</h1>
        <p className="blocked-message">{message}</p>
        <p className="blocked-contact">
          If you believe this is an error, please contact support.
        </p>
        <button className="btn-blocked-signout" onClick={handleSignOut}>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default BlockedPage;
